import React from 'react';
import { QrCode } from '@carbon/icons-react';

export function getReportQrImageUrl({ publicUrl, storedUrl, size = 200 }) {
  if (storedUrl) return storedUrl;
  if (!publicUrl) return null;
  return `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(publicUrl)}`;
}

/**
 * Scannable report QR — no centre logo overlay (matches email template).
 */
export default function ReportQRCode({
  publicUrl,
  storedUrl,
  size = 200,
  alt = 'Report QR code',
  style = {},
}) {
  const qrImageUrl = getReportQrImageUrl({ publicUrl, storedUrl, size });

  if (!qrImageUrl) {
    return (
      <div
        style={{
          width: size,
          height: size,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 12,
          border: '2px dashed #8d8d8d',
          fontSize: '0.75rem',
          color: '#8d8d8d',
          backgroundColor: '#ffffff',
          ...style,
        }}
      >
        QR code will appear here
      </div>
    );
  }

  return (
    <img
      src={qrImageUrl}
      alt={alt}
      style={{
        width: size,
        height: size,
        maxWidth: '100%',
        borderRadius: 8,
        backgroundColor: '#ffffff',
        display: 'block',
        ...style,
      }}
      onError={(e) => {
        if (storedUrl && publicUrl) {
          e.target.src = getReportQrImageUrl({ publicUrl, storedUrl: null, size });
        }
      }}
    />
  );
}

export function ReportQRCodePlaceholder({ size = 88 }) {
  return (
    <div
      style={{
        width: size,
        height: size,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 12,
        backgroundColor: '#ffffff',
        border: '2px solid #e0e0e0',
      }}
    >
      <QrCode size={Math.round(size * 0.45)} style={{ color: '#161616' }} />
    </div>
  );
}
